import nlMarkArt from '@/assets/mascot/nl-mark.png'
import alertBellArt from '@/assets/mitra-3d/alert-bell.png'
import { cn } from '@/lib/utils'

/**
 * The small round mascot mark beside "MoneyMitra Weekly" — in every card's masthead row, the
 * reader's cover and the Get-new-issues row.
 *
 * Market parity (2026-10-28): the mock's `nl-mark.png` (the reading Mitra) on the gold-tinted
 * `--accent-soft` ground, the whole figure letterboxed with `object-contain` inside the circle —
 * it was a green ground before the mock's own mark went gold. `variant="notify"` is the bell-ringing
 * pose (`mitra-3d/alert-bell`) the Get-new-issues row uses, on the same ground.
 */
export default function MascotMark({
  size = 18,
  variant = 'default',
  className,
}: {
  size?: number
  /** 'notify' is the bell-ringing pose used only by the header's "Get new
   *  issues" row; every other call site is the default masthead mark. */
  variant?: 'default' | 'notify'
  className?: string
}) {
  const art = variant === 'notify' ? alertBellArt : nlMarkArt

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-tone-accent-soft',
        className,
      )}
      style={{ width: size, height: size }}
    >
      <img src={art} alt="" className="h-full w-full object-contain" />
    </span>
  )
}
